import React from 'react';
import { ISavedTimeCards } from './SavedTimeCards.interface';
import { KpiCard } from 'app/components/KpiCard';
import styles from './SavedTimeCards.module.scss';
import {
  SavedTimeKpiInfoTooltipContent,
  SavedMoneyKpiInfoTooltipContent
} from 'app/utils/consts';
import { calculateMonthlyDifference } from 'app/utils';

export const SavedTimeCards: React.FC<ISavedTimeCards> = ({
  currency,
  overallEstimatedSavedMoney,
  overallEstimatedSavedTimeInHours,
  usageData
}) => {
  const currentMonth = new Date().getMonth() + 1;
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const defaultData = {
    estimatedSavedMoney: 0,
    estimatedSavedTimeInHours: 0
  };

  const currentData = usageData[currentMonth] || defaultData;
  const previousData = usageData[previousMonth] || defaultData;

  const moneySavedDifference = calculateMonthlyDifference(
    currentData.estimatedSavedMoney,
    previousData.estimatedSavedMoney
  );
  const timeSavedDifference = calculateMonthlyDifference(
    currentData.estimatedSavedTimeInHours,
    previousData.estimatedSavedTimeInHours
  );

  return (
    <div className={styles['kpi-cards-container']}>
      <KpiCard
        title="Total saved time"
        mainLabel="hrs"
        mainData={overallEstimatedSavedTimeInHours.toFixed(2)}
        percentageDifference={moneySavedDifference}
        tooltipContent={SavedTimeKpiInfoTooltipContent}
      />
      <KpiCard
        title="Saved money"
        mainLabel={currency}
        mainData={overallEstimatedSavedMoney.toFixed(2)}
        percentageDifference={timeSavedDifference}
        tooltipContent={SavedMoneyKpiInfoTooltipContent}
      />
    </div>
  );
};
